import type { Active, Announcements, Over, ScreenReaderInstructions, UniqueIdentifier } from '@dnd-kit/core'
import { useTranslation } from 'react-i18next'

/**
 * Annonces du glisser-déposer au clavier, dans la langue de l'interface et par
 * titre de module (RGAA 7.1, 8.7). Par défaut, dnd-kit annonçait en anglais
 * l'identifiant technique : « Picked up draggable item 3f2a… ».
 */
export function useDragAnnouncements(
  order: string[],
  titleOf: (id: string) => string,
): { announcements: Announcements, screenReaderInstructions: ScreenReaderInstructions } {
  const { t } = useTranslation()
  const title = (id: UniqueIdentifier) => titleOf(String(id))
  const position = (id: UniqueIdentifier) => order.indexOf(String(id)) + 1
  const total = order.length
  const cancelled = ({ active }: { active: Active }) => t('sessions.path.dnd.cancel', { title: title(active.id) })

  return {
    screenReaderInstructions: { draggable: t('sessions.path.dnd.instructions') },
    announcements: {
      onDragStart: ({ active }) => t('sessions.path.dnd.start', { title: title(active.id), position: position(active.id), total }),
      onDragOver: ({ active, over }: { active: Active, over: Over | null }) =>
        over ? t('sessions.path.dnd.over', { title: title(active.id), position: position(over.id), total }) : undefined,
      onDragEnd: ({ active, over }: { active: Active, over: Over | null }) =>
        over ? t('sessions.path.dnd.end', { title: title(active.id), position: position(over.id), total }) : cancelled({ active }),
      onDragCancel: cancelled,
    },
  }
}
